var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit02 = function SvgEdit02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M8.84 2.4 3.367 8.193c-.207.22-.407.653-.447.953l-.247 2.16c-.086.78.474 1.314 1.247 1.18l2.147-.366c.3-.053.72-.273.926-.5l5.474-5.794c.946-1 1.373-2.14-.1-3.533C10.9.913 9.787 1.4 8.84 2.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M7.927 3.366A4.084 4.084 0 0 0 11.56 6.8M2 14.666h12"
  })));
};
export default SvgEdit02;